export const END_POINT_NAME: any = {
  EDGE_API: process.env.REACT_APP_END_POINT,
  AI_ENGINE_API: process.env.REACT_APP_AI_ENGINE_END_POINT,
  WSS_END_POINT: process.env.REACT_APP_WSS_END_POINT,
};
